import { useTranslate } from "react-admin";
import { isPhoneValid } from "utils/isPhoneValid";

interface NotificationSettingsShowProps {
  user: any;
  showReminders: boolean;
  showPromo: boolean;
}

const NotificationSettingsShow = ({
  user,
  showReminders,
  showPromo
}: NotificationSettingsShowProps) => {
  const translate = useTranslate();

  if (!user || (!showReminders && !showPromo)) {
    return null;
  }

  const enabledByType: Record<string, boolean> = {};
  (user.reminder_settings || []).forEach((setting: any) => {
    enabledByType[setting.type] = !!setting.enabled;
  });

  const hasEmail = !!user.email && user.email.trim().length > 0;
  const hasPhone = isPhoneValid(user.phone_number);

  const rows: {
    type: string;
    label: string;
    channel: "EMAIL" | "SMS";
    visible: boolean;
  }[] = [
    {
      type: "EMAIL",
      label: translate("users.notification_email"),
      channel: "EMAIL",
      visible: showReminders
    },
    {
      type: "SMS",
      label: translate("users.notification_sms"),
      channel: "SMS",
      visible: showReminders
    },
    {
      type: "EMAIL_PROMO",
      label: translate("users.notification_promo_email"),
      channel: "EMAIL",
      visible: showPromo
    },
    {
      type: "SMS_PROMO",
      label: translate("users.notification_promo_sms"),
      channel: "SMS",
      visible: showPromo
    }
  ];

  return (
    <div className="mb-2">
      <p className="text-[16px] text-mono-primaryTextColor font-[400] font-['Inter'] mb-1">
        {translate("users.notification_settings_title")}:
      </p>
      <ul className="list-disc list-inside">
        {rows
          .filter((row) => row.visible)
          .map((row) => {
            const hasContact = row.channel === "EMAIL" ? hasEmail : hasPhone;
            const isOn = hasContact && !!enabledByType[row.type];
            return (
              <li
                key={row.type}
                className="text-[16px] text-mono-primaryTextColor font-[400] font-['Inter'] pl-4"
              >
                {row.label}:{" "}
                <span className={isOn ? "text-[#0A8463]" : "text-error"}>
                  {isOn ? translate("users.on") : translate("users.off")}
                </span>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

export default NotificationSettingsShow;
